var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration"},[_c('h1',[_vm._v(_vm._s(_vm.$t('passwordSuccess')))]),_c('div',{staticClass:"buttons-wrap"},[_c('a',[_c('button',{on:{"click":_vm.loginUser}},[_vm._v(" "+_vm._s(_vm.$t('enter'))+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }